'use strict';

import Accessibility from "../utils/accessibility";

const Header = {
    el: null,
    app: null,
    lastScrollY: 0,
    toggleMenuButton: null,
    themeSwitchButton: null,
    menuItems: null,
    allMenuItems: null,
    menu: null,
    boundHandleKeyEvents: null,
    boundHandleFocusOut: null,
    topActions: null,
    topActionsDesktopParent: null,
    init: function () {
        Header.el = document.querySelector('.header');
        Header.app = document.querySelector('.app');
        if (Header.el) {
            Header.toggleMenuButton = Header.el.querySelector('.header__toggle');
            Header.themeSwitchButton = Header.el.querySelector('.js-switch-mode');
            Header.menuItems = Header.el.querySelectorAll('.menu-item-has-children > a, .menu-item-has-children > button');
            Header.allMenuItems = Header.el.querySelectorAll('.header__nav > a, .header__nav > button');
            Header.menu = Header.el.querySelector('.header__nav');
            Header.topActions = Header.el.querySelector('#headerTopActions');
            Header.topActionsDesktopParent = Header.topActions ? Header.topActions.parentElement : null;
            Header.moveTopActions();
            Header.setMenuItemsTabIndex(-1);
            Header.boundHandleKeyEvents = this.handleKeyEvents.bind(this);
            Header.boundHandleFocusOut = this.handleFocusOut.bind(this);
           
            this.el.querySelectorAll('.sub-menu').forEach(submenu => {
                if (submenu.classList.contains('expanded')) {
                    submenu.querySelectorAll('a, button').forEach(link => {
                        link.tabIndex = 0;
                    })
                } else {
                    submenu.querySelectorAll('a, button').forEach(link => {
                        link.tabIndex = -1;
                    })
                }
            })
            if (this.toggleMenuButton && window.matchMedia('(max-width: 1024px)').matches) {

                this.menu.setAttribute('role', 'dialog');
                this.menu.setAttribute('aria-modal', 'true');
                this.menu.setAttribute('aria-hidden', 'true');
                this.toggleMenuButton.addEventListener('click', () => {
                    this.el.classList.toggle('navOpened');
                    let expanded = this.el.classList.contains('navOpened');
                    
                    document.body.style.overflowY = expanded ? 'hidden' : 'visible';
                    this.toggleMenuButton.setAttribute('aria-expanded', expanded);
                    this.menu.setAttribute('aria-hidden', !expanded);
                    this.setMenuItemsTabIndex(expanded ? 0 : -1);

                    if (expanded) {
                        document.addEventListener('focusin', this.handleFocusOut);
                        document.addEventListener('keydown', this.handleKeyEvents);
                    } else {
                        document.removeEventListener('focusin', this.handleFocusOut);
                        document.removeEventListener('keydown', this.handleKeyEvents);
                        this.resetSubMenus();
                    }
                });

                this.toggleMenuButton.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.toggleMenuButton.click();
                    }
                });

            }
            if (this.themeSwitchButton) {
                this.themeSwitchButton.addEventListener('click', this.toggleTheme.bind(this));
            }
            
            this.initMobileSubMenus();
            this.initDesktopSubMenus();
            window.addEventListener('resize', () => {
                this.initMobileSubMenus();
                this.initDesktopSubMenus();
                this.moveTopActions();
            });

            this.loadTheme();
            this.watchScroll(); 

            window.addEventListener('scroll', this.watchScroll)
        }
    },
    initMobileSubMenus: function () {
        // Uniquement mobile
        if (window.matchMedia('(max-width: 1024px)').matches) {
            this.menuItems.forEach(item => {
                if (item.dataset.mobileSubmenuBound) {
                    return;
                }
                item.dataset.mobileSubmenuBound = 'true';

                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let parentLi = item.parentElement;
                    let subMenu = parentLi.querySelector('.sub-menu');
                    let isExpanded = subMenu.classList.contains('expanded');

                    if (!isExpanded) {
                        subMenu.classList.add('expanded');
                        item.setAttribute('aria-expanded', 'true');

                        subMenu.querySelectorAll('a, button').forEach(link => {
                            link.tabIndex = 0;
                        });

                        parentLi.parentElement.querySelectorAll('.sub-menu').forEach(menu => {
                            if (menu !== subMenu) {
                                menu.classList.remove('expanded');
                                menu.previousElementSibling.setAttribute('aria-expanded', 'false');
                                menu.querySelectorAll('a, button').forEach(link => {
                                    link.tabIndex = -1;
                                });
                            }
                        });
                    } else {
                        subMenu.classList.remove('expanded');
                        item.setAttribute('aria-expanded', 'false');
                        this.resetSubMenus();
                        subMenu.querySelectorAll('a, button').forEach(link => {
                            link.tabIndex = -1;
                        });
                    }
                });
            });
        }
    },
    initDesktopSubMenus: function () {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            this.menuItems = document.querySelectorAll('.menu-item-has-children > a, .menu-item-has-children > button');

            this.menuItems.forEach(link => {
                const parentLi = link.parentElement;
                const subMenu = parentLi.querySelector('.sub-menu');

                // Initial state: submenu hidden, links not tabbable
                link.setAttribute('aria-expanded', 'false');
                subMenu.querySelectorAll('a').forEach(a => a.tabIndex = -1);

                if (link.dataset.desktopSubmenuBound) {
                    return;
                }
                link.dataset.desktopSubmenuBound = 'true';

                const openSubMenu = () => {
                    link.setAttribute('aria-expanded', 'true');
                    parentLi.classList.add('hovered--')
                    subMenu.classList.add('expanded');
                    subMenu.querySelectorAll('a, button').forEach(a => a.tabIndex = 0);
                };

                const closeSubMenu = () => {
                    link.setAttribute('aria-expanded', 'false');
                    parentLi.classList.remove('hovered--')
                    subMenu.classList.remove('expanded');
                    subMenu.querySelectorAll('a, button').forEach(a => a.tabIndex = -1);
                };

                // Keyboard handling on the parent link
                link.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        const isOpen = link.getAttribute('aria-expanded') === 'true';
                        if (!isOpen) {
                            openSubMenu();
                            const firstLink = subMenu.querySelector('a, button');
                            if (firstLink) firstLink.focus();
                        } else {
                            closeSubMenu();
                        }
                    }
                });

                // Close with Escape inside the submenu
                subMenu.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape') {
                        closeSubMenu();
                        link.focus();
                    }
                });

                // Close when leaving the submenu
                subMenu.addEventListener('focusout', () => {
                    setTimeout(() => {
                        if (!parentLi.contains(document.activeElement)) {
                            closeSubMenu();
                        }
                    }, 10);
                });

                // Optional: handle mouse too
                link.addEventListener('mouseenter', openSubMenu);
                parentLi.addEventListener('mouseleave', closeSubMenu);
            });
        }
    },
    // Moves the actual DOM node (no clone) between its desktop position and
    // the start of the burger menu on mobile, so tab order matches visual
    // order once the menu is open. Single block, no content duplication and
    // no aria-hidden to sync: .header__nav is visibility:hidden when the
    // menu is closed, so this block naturally follows the same behavior as
    // the menu links.
    moveTopActions: function () {
        if (!this.topActions || !this.menu || !this.topActionsDesktopParent) return;

        const isMobile = window.matchMedia('(max-width: 1024px)').matches;

        if (isMobile && this.topActions.parentElement !== this.menu) {
            this.menu.insertBefore(this.topActions, this.menu.firstChild);
        } else if (!isMobile && this.topActions.parentElement !== this.topActionsDesktopParent) {
            this.topActionsDesktopParent.appendChild(this.topActions);
        }
    },
    resetSubMenus: function () {
        this.el.querySelectorAll('.menu-item-has-children').forEach(item => {
            const subMenu = item.querySelector('.sub-menu');
            const link = item.querySelector('a, button');

            if (subMenu && link) {
                subMenu.classList.remove('expanded');
                link.setAttribute('aria-expanded', 'false');
            }
        });
    },
    handleFocusOut: function (event) {
        if (!Header.el.contains(event.target) && Header.el.classList.contains('navOpened')) {
            this.el.classList.remove('navOpened');
            document.body.style.overflowY = 'visible';
            this.toggleMenuButton.setAttribute('aria-expanded', false);
            this.setMenuItemsTabIndex(-1);
            document.removeEventListener('focusin', this.handleFocusOut.bind(this));
        }
    },
    handleKeyEvents: function (e) {
        if (Header.el.classList.contains('navOpened')) {
            Accessibility.trapFocus(Header.el.querySelector('.header__ctn-right'), e, () => {
                Header.toggleMenuButton.click();
            });
            if (e.key === 'Escape' || e.keyCode === 27) {
                Header.toggleMenuButton.focus();
            }
        }

        
    },
    toggleTheme: function () {
        const isDarkMode = this.app.classList.toggle('dark-mode');
        localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
        this.updateThemeIcon(isDarkMode);
        this.themeSwitchButton.setAttribute('aria-pressed', isDarkMode);
    },
    setMenuItemsTabIndex: function (index) {
        this.allMenuItems.forEach(item => {
            item.tabIndex = index;
        });
    },
    loadTheme: function () {
        const savedTheme = localStorage.getItem('theme') || 'light';
        if (savedTheme === 'dark') {
            this.app.classList.add('dark-mode');
            this.themeSwitchButton.setAttribute('aria-pressed', true);
        } else {
            this.app.classList.remove('dark-mode');
            this.themeSwitchButton.setAttribute('aria-pressed', false);
        }
        this.updateThemeIcon(savedTheme === 'dark');
    },
    updateThemeIcon: function (isDarkMode) {
        if (!this.themeSwitchButton) return;
        const icon = this.themeSwitchButton.querySelector('i');
        const text = this.themeSwitchButton.querySelector('.visually-hidden');
        if (icon) {
            icon.className = isDarkMode ? 'icon-sun' : 'icon-moon';
        }
        if (text) {
            text.textContent = isDarkMode ? text.getAttribute('data-text-dark') : text.getAttribute('data-text-light');
        }
    }, 
    watchScroll: function (){
        const y = window.scrollY;

        // "Scrolled" state (existing)
        if (y !== 0) Header.el.classList.add('scrolled--');
        else Header.el.classList.remove('scrolled--');

        // hidden-- = desktop only. On mobile: never (the <li> stay visible).
        if (!window.matchMedia('(min-width: 1025px)').matches) {
            Header.el.classList.remove('hidden--');
            Header.lastScrollY = y;
            return;
        }

        // Auto-hide: header hides on scroll down, reappears (fade-in) on
        // scroll up. Disabled while the mobile menu is open.
        if (!Header.el.classList.contains('navOpened')) {
            const delta = y - Header.lastScrollY;
            const threshold = 80; // stays visible near the top of the page

            if (y <= threshold) {
                Header.el.classList.remove('hidden--');
            } else if (delta > 4) {
                Header.el.classList.add('hidden--');      // scroll down
            } else if (delta < -4) {
                Header.el.classList.remove('hidden--');    // scroll up
            }
        }

        Header.lastScrollY = y;
    }
};

export default Header;